var _rect, _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCriticalIllnessMenuIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 72,
    height: 67,
    viewBox: "0 0 72 67",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 71.7736,
    height: 67,
    rx: 17.5738,
    fill: "#F7F6F2"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_7153_14248)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M21.5898 21.0688H25.6252L27.568 30.6661",
    stroke: "#187C85",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.3906 27.2578H41.0144",
    stroke: "#187C85",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.0233 44.9314C32.9626 44.9314 36.156 41.738 36.156 37.7987C36.156 33.8594 32.9626 30.666 29.0233 30.666C25.084 30.666 21.8906 33.8594 21.8906 37.7987C21.8906 41.738 25.084 44.9314 29.0233 44.9314Z",
    fill: "url(#paint0_linear_7153_14248)",
    fillOpacity: 0.36,
    stroke: "#187C85",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.022 41.3009C30.9564 41.3009 32.5246 39.7328 32.5246 37.7984C32.5246 35.864 30.9564 34.2959 29.022 34.2959C27.0877 34.2959 25.5195 35.864 25.5195 37.7984C25.5195 39.7328 27.0877 41.3009 29.022 41.3009Z",
    fill: "url(#paint1_linear_7153_14248)",
    fillOpacity: 0.96,
    stroke: "#187C85",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.1358 44.4986C46.736 44.4986 48.0332 43.2013 48.0332 41.6011C48.0332 40.0009 46.736 38.7036 45.1358 38.7036C43.5355 38.7036 42.2383 40.0009 42.2383 41.6011C42.2383 43.2013 43.5355 44.4986 45.1358 44.4986Z",
    stroke: "#187C85",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.0078 27.2412H36.2331C39.5969 27.2412 40.5682 32.3756 40.5682 32.3756",
    stroke: "#187C85",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.5977 40.0746L49.9567 38.7036",
    stroke: "#187C85",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.4062 32.9194H41.8498C43.3207 32.9194 44.5086 34.1128 44.5086 35.5782L45.1303 41.5064",
    stroke: "#187C85",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.5781 38.1648L29.4718 37.5098",
    stroke: "#187C85",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_7153_14248",
    x1: 13.9995,
    y1: 48.5,
    x2: 38.2818,
    y2: 33.1555,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.21875,
    stopColor: "#ED1C2C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.595,
    stopColor: "#53BCC8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFE9B1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_7153_14248",
    x1: 19.4985,
    y1: 38,
    x2: 32.9816,
    y2: 36.8087,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.21875,
    stopColor: "#ED1C2C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.595,
    stopColor: "#53BCC8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFE9B1"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_7153_14248"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 30,
    height: 26,
    fill: "white",
    transform: "translate(20.8867 20.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCriticalIllnessMenuIcon);
export default __webpack_public_path__ + "static/media/critical-illness-menuIcon.df97f408750f81ba2a413d09cac3930f.svg";
export { ForwardRef as ReactComponent };